const Search = {
    namespaced: true,
    state: {
        queryString: null,
    },
    mutations: {
        SET_QUERY_STRING(state, string) {
            state.queryString = string;
        },
    },
    actions: {
        setQueryString({ commit }, string) {
            commit('SET_QUERY_STRING', `"${string}"`);
        },
    },
};

export default Search;
